import type * as lazyIndex from './lazyIndex';
import { default as setFolderSortBy } from './actions/setFolderSortBy';
import { LazyAction, LazyModule, registerLazyOrchestrator, LazyImport } from 'owa-bundling';
import emptyFolderStoreUpdate from 'owa-folder-emptyfolder/lib/actions/emptyFolderStoreUpdate';
import markAllAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markAllAsReadStoreUpdate';
import {
    onNewFolderNotification,
    onUpdateFolderNotification,
} from 'owa-mail-actions/lib/folderNotificationActions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MailFolderStore" */ './lazyIndex'),
    { name: 'MailFolderStore' }
);

registerLazyOrchestrator(
    onNewFolderNotification,
    lazyModule,
    m => m.onNewFolderRowNotificationOrchestrator
);

registerLazyOrchestrator(markAllAsReadStoreUpdate, lazyModule, m => m.markAllAsReadOrchestrator);
registerLazyOrchestrator(
    emptyFolderStoreUpdate,
    lazyModule,
    m => m.emptyFolderStoreUpdateOrchestrator
);
registerLazyOrchestrator(
    onUpdateFolderNotification,
    lazyModule,
    m => m.onUpdateFolderNotificationOrchestrator
);
registerLazyOrchestrator(setFolderSortBy, lazyModule, m => m.setFolderSortByOrchestrator);

export const lazyDismissMailFolderTextField: LazyAction<
    typeof lazyIndex.dismissMailFolderTextFieldMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.dismissMailFolderTextFieldMutator);

export const lazyRemoveSortByOverride: LazyAction<
    typeof lazyIndex.removeSortByOverrideMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeSortByOverrideMutator);

export const lazyGetFolderUrl: LazyImport<typeof lazyIndex.getFolderUrl, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getFolderUrl);

export const lazyGetFolderViewStateFromId: LazyImport<
    typeof lazyIndex.getFolderViewStateFromId,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFolderViewStateFromId);

export const lazySetCustomFolderColor: LazyAction<
    typeof lazyIndex.setCustomFolderColorMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setCustomFolderColorMutator);

export const lazySetFolderCountDisplayMode: LazyAction<
    typeof lazyIndex.setFolderCountDisplayModeMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setFolderCountDisplayModeMutator);

export const lazyInitializeMailboxFolderExpansionState: LazyAction<
    typeof lazyIndex.initializeMailboxFolderExpansionState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeMailboxFolderExpansionState);

export const lazyUpdateMailboxFolderExpansionState: LazyAction<
    typeof lazyIndex.updateMailboxFolderExpansionState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateMailboxFolderExpansionState);

export const lazyRemoveMailboxFolderExpansionIds: LazyAction<
    typeof lazyIndex.removeMailboxFolderExpansionIds,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeMailboxFolderExpansionIds);

export const lazyRemoveSharedMailboxFolderExpansionState: LazyAction<
    typeof lazyIndex.removeSharedMailboxFolderExpansionState,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeSharedMailboxFolderExpansionState);
